import $ from 'jquery';
import Swal from 'sweetalert2';

export function initPatrol() {
    const pageId = $('#page-id').data('page');
    if (pageId !== 'patrol') return;

    console.log('[Patrol] Initializing Patrol Module');

    // NOTE: Edit, Delete, and Form Submit are now handled by:
    // - global-crud.js ([data-url-json] for edit, generic form submit)
    // - button-utils.js (.btn-view-detail)
    // Ensure the table has class .datatable or window.table is set for auto-refresh.

    $(document).on('shown.bs.modal', '#modalViewPatrol', function () {
        let lat = $(this).find('[data-view-key="latitude"]').text();
        let lng = $(this).find('[data-view-key="longitude"]').text();
        
        let $btnMaps = $('#btn-open-maps-patrol');
        if (lat && lng && lat !== '0.000' && lat !== '0.00000000') {
            $btnMaps.attr('href', `https://www.google.com/maps?q=${lat},${lng}`).show();
        } else {
            $btnMaps.hide();
        }
    });

    // Handle photo previews when editing a patrol record
    $(document).on('click', '.btn-edit[data-bs-target="#modalPatrol"]', async function () {
        const url = $(this).data('url-json');
        if (!url) return;
        
        try {
            const response = await fetch(url);
            const result = await response.json();
            if (result.status === 'success') {
                const data = result.data;
                const photoFields = ['foto_sebelum', 'foto_progres', 'foto_sesudah'];
                
                // Get the base url / image prefix from detail image to match base URL
                const baseImagePrefix = $('img[data-view-image-prefix]').first().data('view-image-prefix') || '/patrol/photo/';
                
                photoFields.forEach(field => {
                    const val = data[field];
                    const $preview = $(`#preview_${field}`);
                    if (val && val !== '-' && val !== '') {
                        $preview.find('a').attr('href', baseImagePrefix + val);
                        $preview.show();
                    } else {
                        $preview.hide();
                    }
                });
            }
        } catch (e) {
            console.error('[Patrol] Failed to load photo previews for edit form:', e);
        }
    });

    // Reset photo previews when edit modal is closed
    $(document).on('hidden.bs.modal', '#modalPatrol', function () {
        $('#preview_foto_sebelum, #preview_foto_progres, #preview_foto_sesudah').hide();
    });
}
